/*
 * Copyright '2025' Dell Inc. or its subsidiaries. All Rights Reserved.
 */
export const environment = {
  production: false,
  rootUrl: window.location.origin,
  backendUrl: "",
  cdnBaseURL: "/cdn/",
  assetsLibraryVersion: "",
  releaseTogglesEndpoint: "/tdm-release-toggling/public/toggles",
  releaseToggleUpdateEndpoint: "/tdm-release-toggling/toggles",
  feedbackEndpoint: "/tdm-users/feedback",
  userInfoUrl: "/tdm-users/public/current-user",
  alerts: "/tdm-alerts/public/alerts",
  notificationsCount: "/tdm-notifications/notifications/unread-count",
  tdpINTHostname: "csm-td-int.dell.com",
  tdpStagingHostname: "csm-td-staging.dell.com",
  tdpProdHostname: "tdm.dell.com",
  tdpLocalHostname: "localhost",
  glassboxScriptUrl:
    "https://nexus.ensighten.com/dell/externalDev/Bootstrap.js",
  pendoApiKey: "",
  chatBotResourceRoute: "tdp-chat-widget-mfe/main.js",
  graphUrl: "/graphql",
  unauthenticatedRoutes: [
    "/",
    "/portal",
    "/portal/**",
    "/registration",
    "/registration/**",
    "/login",
    "/logout",
    "/file-upload",
    "/service-activation",
    "/service-activation/**",
    "/dispatch/v2/selectparts",
    "/dispatch/v2/dispatchsaml",
    "/dispatch/v2/defectivecomponentsservice",
    "/dispatch/v2/dispatchpartsservice",
    "/dispatch/v2/partissuedservice",
    "/dispatch/v2/mfgdateservice",
    "/selectparts",
    "/dispatchsaml",
    "/defectivecomponentsservice",
    "/dispatchpartsservice",
    "/partissuedservice",
    "/mfgdateservice",
    "/dda/dataerase/downloadagent",
    "/dda-unauth-service/erasure-agent/download",
    "/dda-unauth-service/logs/upload",
    "/dda-unauth-service/csrf/token",
    "/adazure",
    "/adlogin",
    "/adlogout",
    "/ars/purchase-credit",
    "/ars/asset-appraisal",
    "/ars/asset-appraisal/**",
  ],
  companyAttestationEnabled: false,
  sctHost: "techdirect-uat2.servicecentral.com",
};
